import ReactPaginate from 'react-paginate'
import st from './Pagination.module.scss'
import { ReactComponent as ArrowLeft } from './arrowLf.svg'
import { ReactComponent as ArrowRight }  from './arrowRg.svg'
import {useEffect, useState} from 'react'
import {isMobile, windowResize} from 'helpers'
import {useSearchParams} from 'react-router-dom';

export const Pagination = ({ meta }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [hasMobile, setHasMobile] = useState(isMobile)
    useEffect(() => windowResize(setHasMobile, 768), [setHasMobile]);

    const handlePageClick = (e) => {
        window.scroll({ top: 0, behavior: 'smooth' })
        setSearchParams({
            page: e.selected + 1
        })
    }
    console.log(meta)

    return meta?.last_page !== 1 && (
        <ReactPaginate
            initialPage={searchParams.get('page')-1}
            className={st.pagination}
            breakClassName={st.item}
            breakLinkClassName={st.link}
            pageCount={meta?.last_page}
            pageRangeDisplayed={hasMobile ? 3 : 10}
            onPageChange={handlePageClick}
            renderOnZeroPageCount={undefined}
            breakLabel={null}
            disableInitialCallback={true}
            marginPagesDisplayed={-1}
            activeClassName={st.active}
            nextLabel={<ArrowRight />}
            previousLabel={<ArrowLeft />}
        />
    )
}
